export const getUserAvatar = (avatar?: string, publicUrl?: string) => {
  if (!avatar) {
    // return default avatar when user don't have avatar
    return process.env.REACT_APP_KATALON_DEFAULT_AVATAR_URL;
  }
  if (avatar.startsWith('http')
    || avatar.startsWith('https') || avatar.startsWith('data:')) {
    // the avatar is full url, just return it
    return avatar;
  }

  // the avatar is relative url, append public url
  return `${publicUrl}${avatar}`;
};
